<template>
  <div>
    <el-dialog
      :title="title"
      :visible="nameMixShow"
      width="1000px"
      @close="close"
      @open="openInit"
      append-to-body
    >
      <div class="localsList mix-wrap">
        <p class="batch-p">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-input
            placeholder="批量修改名称"
            type="text"
            v-model="comVal"
            :disabled="!checkedDatas.length"
            @input="(val) => batchChange('name', val)"
          ></el-input>
        </p>
        <el-checkbox-group
          v-model="checkedDatas"
          @change="(val)=>handleCheckedDatasChange('name',nameMsgList,val)"
        >
          <el-checkbox v-for="item in dataList" :label="item.id" :key="item.id"
            ><el-input
              placeholder="名称"
              type="text"
              v-model="item.name"
            ></el-input
          ></el-checkbox>
        </el-checkbox-group>
        <!-- <el-row :gutter="10" v-for="item in dataList" :key="item.id"> -->
        <!-- <el-col :span="6" style="line-height:40px">
                        <span class="mixName">{{item.name}}</span>
                    </el-col> -->
        <!-- <el-col :span="18">
            <el-input
              placeholder="名称"
              type="text"
              v-model="item.name"
            ></el-input>
          </el-col>
        </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixBatchOperate from "@/views/adManagement/assets/js/mixBatchOperate";
export default {
  mixins: [mixBatchOperate],
  props: {
    nameMixShow: {
      type: Boolean,
      default: () => false,
    },
    nameMsgList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: () => "链接",
    },
  },
  data() {
    return {
      dataList: JSON.parse(JSON.stringify(this.nameMsgList)),
    };
  },
  methods: {
    close() {
      this.backToInit(this.nameMsgList);
      this.$emit("update:nameMixShow", false);
    },
    openInit() {},
    sure() {
      this.$emit("setMixMsg", "name", this.dataList);
      this.close();
    },
  },
  watch: {
    nameMsgList: {
      handler() {
        this.dataList = JSON.parse(JSON.stringify(this.nameMsgList));
      },
    },
    deep: true,
  },
};
</script>
<style lang="scss" scoped>
.localsList {
  max-height: 700px;
  overflow-x: hidden;
  overflow-y: auto;
  .el-row {
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.mix-wrap {
  .batch-p {
    display: flex;
    align-items: center;
    .el-input {
      margin-left: 10px;
      width: 70%;
    }
  }
  .el-checkbox-group {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    .el-checkbox {
      width: 70%;
      margin-bottom: 10px;
    }
    .el-checkbox__label {
      width: 100%;
    }
  }
}
</style>